// extracted by mini-css-extract-plugin
export default {"tableu":"doctorList_tableu__Uz4ds","isloading":"doctorList_isloading__2UOBa","rowtable":"doctorList_rowtable__mfm4S"};